import axios from 'axios';
import { getBackendURL, onRequest, onError, onSuccess } from '../interceptors';
import store from '../store'; // Import the store
import { InternalAxiosRequestConfig } from 'axios';

const axiosInstanceQueries = axios.create({
  headers: {
    Accept: 'application/json',
  },
  baseURL: getBackendURL(),
});

axiosInstanceQueries.interceptors.request.use(
  (config) => {
    return onRequest(config, null, store) as InternalAxiosRequestConfig;
  },
  (error) => {
    return onError(error, null, store);
  },
);

axiosInstanceQueries.interceptors.response.use(
  (response) => {
    return onSuccess(response, null, store);
  },
  (error) => {
    return onError(error, null, store);
  },
);

export default axiosInstanceQueries;
